




import { Component, Vue } from 'vue-property-decorator'
import PagedLocality from './page/_page.vue'

@Component({ components: { PagedLocality } })
export default class Locality extends Vue {}
